// FAQ.js – Seite /faq: aufklappbare Fragen (<details>) aus src/data/faq.js, gruppiert nach Themen.
import "./Home.css";
import "./custom.css";
import usePageMeta from "../../usePageMeta";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import faq from "../../data/faq";
import { JsonLd } from "../Strukturdaten";

// FAQ-Strukturdaten (schema.org/FAQPage); landen beim Vorab-Rendering im HTML
const schema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faq.flatMap((g) =>
    g.fragen.map((f) => ({
      "@type": "Question",
      name: f.frage,
      acceptedAnswer: { "@type": "Answer", text: f.antwort },
    }))
  ),
};

function FAQ() {
  usePageMeta({
    path: "/faq",
    title: "Häufige Fragen zu Baumfällung & Baumpflege | Forst & Flur",
    description:
      "Antworten auf häufige Fragen an Forst & Flur aus Probsteierhagen: Ablauf und Kosten, Fällzeiten, Genehmigungen, Schnittgut und Landschaftspflege mit der Raupe.",
  });

  return (
    <div>
      <JsonLd daten={schema} />

      <div className="ff-page-hero">
        <div className="ff-page-hero__content">
          <span className="ff-eyebrow">Forst &amp; Flur</span>
          <h1 className="ff-page-hero__title">Häufige Fragen</h1>
          <p className="ff-page-hero__sub">Was Kunden vor einem Auftrag am häufigsten wissen möchten</p>
        </div>
      </div>

      <div className="custom-dark-green text-white">
        <Container className="py-5">
          <Row className="justify-content-center">
            <Col xs={12} lg={9}>
              {faq.map((g) => (
                <section key={g.thema} className="ff-faq">
                  <h2 className="ff-article-h3">{g.thema}</h2>
                  {g.fragen.map((f) => (
                    <details key={f.frage} className="ff-faq__item">
                      <summary className="ff-faq__q">{f.frage}</summary>
                      <div className="ff-faq__a">
                        <p>{f.antwort}</p>
                        {f.link && (
                          <Link to={f.link.to} className="ff-faq__link" onClick={() => window.scrollTo(0, 0)}>
                            {f.link.label}
                          </Link>
                        )}
                      </div>
                    </details>
                  ))}
                </section>
              ))}
            </Col>
          </Row>

          <Row className="justify-content-center mt-4">
            <Col xs={12} lg={9} className="text-center">
              <p className="fs-5 text-shadow">Ihre Frage war nicht dabei? Rufen Sie an oder schreiben Sie mir.</p>
              <Link to="/kontakt" className="btn-ff-primary" onClick={() => window.scrollTo(0, 0)}>
                Frage stellen
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default FAQ;
